import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { InstacartAccount } from '@/models/instacartAccount';

export const fetchInstacartAccount = async (email: string): Promise<InstacartAccount> => {
  const response = await queryExecute({
    query: graphql(`
      query InstacartAccount($email: String!) {
        instacartAccount(email: $email) {
          id
          isActive
          isClosed
          isEbtAccount
          user
          email
          phoneNumber
          country
          cookie
          csrfToken
          notes
          operatorId
          lastUsedAt
          lastLoginSuccess
          lastLoginFailure
          isLocked
          lockedAt
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      email,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.instacartAccount;
};
